<template>
  <el-card>
    <el-alert
      v-if="unauthorised"
      class="text-left mb-4"
      title="Unauthorised"
      type="error"
      :closable="false"
    >
      You are not authorised to view this page.
    </el-alert>

    <el-alert
      v-if="!unauthorised"
      class="text-left mb-4"
      :title="title"
      type="warning"
      :closable="false"
    >
      This link will only work once. Do not refresh the page.
    </el-alert>

    <el-form
      v-if="!isLoading && !unauthorised"
      @submit.native.prevent="$emit('submit')"
    >
      <el-form-item class="mb-1">
        <el-input
          v-model="code"
          placeholder="Account Code"
          disabled
        />
      </el-form-item>
      <el-form-item class="mb-1">
        <el-select
          v-model="provider"
          class="w-100"
          placeholder="Select Provider"
        >
          <el-option
            v-for="platform in platforms"
            :key="platform.value"
            :label="platform.label"
            :value="platform.value"
          />
        </el-select>
      </el-form-item>
      <el-form-item class="mb-1">
        <el-input
          v-model="redirect"
          placeholder="OAuth Endpoint"
          clearable
        />
      </el-form-item>

      <el-form-item class="mb-1">
        <el-input
          v-model="client_id"
          placeholder="Client ID"
          clearable
        />
      </el-form-item>

      <el-form-item class="mb-1">
        <el-input
          v-model="client_secret"
          placeholder="Client Secret"
          show-password
          clearable
        />
      </el-form-item>
    </el-form>

    <el-divider />

    <div v-if="!isLoading && !unauthorised">
      <p>
        Redirect URL: <b>{{ redirect_uri }}</b>
      </p>
      <el-button
        v-clipboard:copy="redirect_uri"
        v-clipboard:success="() => $message.success('Redirect URL copied to clipboard')"
        style="padding: 3px 0"
        type="text"
      >
        Copy Redirect URL
      </el-button>
    </div>

    <el-divider />

    <el-button
      v-if="!unauthorised"
      type="primary"
      class="w-100"
      @click.native="saveConfiguration"
    >
      Save
    </el-button>

    <el-button
      v-if="unauthorised"
      type="primary"
      class="w-100"
      @click.native="redirectToSignIn"
    >
      Return to Sign In
    </el-button>
  </el-card>
</template>
<script>
import Request, { GET, POST } from '@/plugins/sdk/Request'

export default {
  data () {
    return {
      isLoading: false,
      provider: '',
      code: '',
      redirect: '',
      client_id: '',
      client_secret: '',
      platforms: [ { label: 'Microsoft', value: 'Microsoft' } ],
      unauthorised: false,
      account: '',
      redirect_uuid: ''
    }
  },
  computed: {
    title () {
      return this.account ? 'One Time SSO Setup for: ' + this.account : 'Configure SSO'
    },
    redirect_uri () {
      return 'https://' + window.location.host + '/api/v3/authenticate/sso/callback/' + this.redirect_uuid
    }
  },
  created () {
    console.log(this.$route.query.code)
    if (!this.$route.query.code) {
      this.unauthorised = true
    } else {
      this.loadConfiguration()
    }
  },
  methods: {
    async loadConfiguration () {
      this.isLoading = true
      const request = await (Object.assign(new Request(), {
        method: GET,
        _pathname: 'authenticate/configure/' + this.$route.query.code
      })).build()

      const response = await fetch(request)

      if (response.ok) {
        const data = await response.json()
        this.code = data.code
        this.account = data.account
        this.redirect_uuid = data.redirect_uuid
      } else {
        this.unauthorised = true
      }

      this.isLoading = false
    },
    async saveConfiguration () {
      const request = Object.assign(new Request(), {
        method: POST,
        _pathname: 'authenticate/configure/' + this.$route.query.code,
        body: {
          platform: this.provider,
          redirect: this.redirect.replace('authorize', ''),
          client_id: this.client_id,
          client_secret: this.client_secret
        }
      })

      const response = await fetch(await request.build())

      if (response.ok) {
        this.redirectToSignIn()
      } else {
        this.$message.error('Failed to save configuration')
      }
    },
    redirectToSignIn () {
      this.$router.push({ name: 'sign-in' })
    }
  }
}
</script>
